export default class Resource {
    constructor(model) {
        this.id = model.id;
        this.worker_id = model.worker_id;
        this.first_name = model.first_name;
        this.surname = model.surname;
        this.location = model.location;
        this.lat = model.lat;
        this.lng = model.lng;
        this.radius = model.radius;
        this.cscs_card = model.cscs_card;
        this.rate = model.rate;
        this.job_title = model.job_title;
        this.has_own_transport = model.has_own_transport;
        this.has_employer_reference = model.has_employer_reference;
        this.date_available = model.date_available;
        this.deleted_at = model.deleted_at;
        this.created_at = model.created_at;
        this.updated_at = model.updated_at;
    }

    // Custom Methods
}
